import { RawRunEvent } from '../../utils/type'
import { STATIC_DATA_STATES } from '../chart-components'

export interface RunErrors {
    number: boolean
    // eslint-disable-next-line camelcase
    section_id: boolean
    start: boolean
    type: boolean
    startMD: boolean
    finalMD: boolean
    tubularsInterval: boolean
}

export interface Errors {
    run: RunErrors
    messages: { run: string }
}

export const emptyRunErrors: RunErrors = {
    finalMD: false,
    number: false,
    section_id: false,
    start: false,
    startMD: false,
    type: false
}

export const getEmptyErrors = (): Errors => ({
    run: { ...emptyRunErrors },
    messages: { run: '' }
})

export const emptyRawRunEvent: RawRunEvent = {
    cementedPlugs: [],
    number: null,
    section_id: null,
    start: null,
    end: null,
    state: STATIC_DATA_STATES.EMPTY,
    tubularsIntervalPerTime: false,
    type: null,
    finalMD: { value: null, uom: null },
    id: null,
    startMD: { value: null, uom: null }
}
